import PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap';
function ModalInformations({ show, onHide, title, message, description, showDescription, setShowDescription }) {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{message()}
        {showDescription && <div style={{ marginTop: '15px' }}>{description()}</div>}
        <br />
        <Button style={{marginTop: showDescription ? '15px' : '0'}} variant="link" onClick={setShowDescription}>
          {showDescription ? 'Masquer la suite' : 'Pour en savoir plus, cliquez ici'}
        </Button>
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onHide}>
          Fermer
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalInformations;

ModalInformations.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.any,
  message: PropTypes.string.isRequired,
};
